// extracted by mini-css-extract-plugin
export default {"customStyles":"detail_customStyles__HX-Y9","adm-swiper-slide":"detail_adm-swiper-slide__J0dAH","adm-swiper-slide-active":"detail_adm-swiper-slide-active__4JFB4"};